import { Box, Button, Grid, Link, SxProps, Theme, Typography } from "@mui/material";
import { SectionContainer } from "src/modules/SectionContainer/SectionContainer";
import { SectionTitle } from "src/modules/SectionTitle/SectionTitle";
import { SectionSubtitle } from "src/modules/SectionSubtitle/SectionSubtitle";

export const Pricing = () => {
  return (
    <SectionContainer>
      <SectionTitle>料金体系</SectionTitle>
      <SectionSubtitle>お客様の要件に合わせた最適なプランをご提案いたします</SectionSubtitle>
      <Grid container spacing={4}>
        <Grid item xs={12} md={4}>
          <Box sx={pricingCardSx}>
            <Typography variant="h3" sx={pricingPlanNameSx}>
              ライトプラン
            </Typography>
            <Box component="ul" sx={pricingFeaturesSx}>
              <li>L1エンジニアによる対応</li>
              <li>基本的な監視・問い合わせ対応</li>
              <li>定型的な対応に最適</li>
              <li>小規模システム向け</li>
            </Box>
          </Box>
        </Grid>
        <Grid item xs={12} md={4}>
          <Box sx={recommendedPricingCardSx}>
            <Box sx={pricingRecommendedBadgeSx}>おすすめ</Box>
            <Typography variant="h3" sx={pricingPlanNameSx}>
              プレミアムプラン
            </Typography>
            <Box component="ul" sx={pricingFeaturesSx}>
              <li>L1＋L2エンジニアによる対応</li>
              <li>高度な監視・問い合わせ対応</li>
              <li>メニュー外の複雑な問題にも対応</li>
              <li>ハイエンドエンジニアによる専門的サポート</li>
              <li>中～大規模システム向け</li>
            </Box>
          </Box>
        </Grid>
        <Grid item xs={12} md={4}>
          <Box sx={pricingCardSx}>
            <Typography variant="h3" sx={pricingPlanNameSx}>
              カスタムプラン
            </Typography>
            <Box component="ul" sx={pricingFeaturesSx}>
              <li>お客様の要件に合わせたカスタマイズ</li>
              <li>個別メニューの選択が可能</li>
              <li>専属PM・運用チームの配置</li>
              <li>特殊な環境や要件に最適</li>
              <li>大規模・エンタープライズ向け</li>
            </Box>
          </Box>
        </Grid>
      </Grid>
      <Box sx={{ textAlign: "center" }}>
        <Button component={Link} href="/#Contact" variant="contained" sx={pricingContactSx}>
          料金はお問い合わせください
        </Button>
      </Box>
    </SectionContainer>
  );
};

const pricingCardSx: SxProps<Theme> = (theme) => ({
  border: "2px solid #e9ecef",
  borderRadius: "15px",
  padding: "40px 30px",
  textAlign: "center",
  position: "relative",
  background: "white",
  transition: "all 0.3s ease",
  height: "100%",
});

const recommendedPricingCardSx: SxProps<Theme> = (theme) => ({
  ...pricingCardSx(theme),
  borderColor: "#28a745",
  boxShadow: "0 15px 35px rgba(40,167,69,0.2)",
});

const pricingPlanNameSx: SxProps<Theme> = {
  fontSize: "1.5rem",
  marginBottom: "15px",
  color: "#1a1a2e",
  fontWeight: 600,
};

const pricingFeaturesSx: SxProps<Theme> = {
  listStyle: "none",
  margin: "20px 0",
  textAlign: "left",
  "& li": {
    padding: "8px 0",
    color: "#666",
    position: "relative",
    "&::before": {
      content: '"✓"',
      color: "#28a745",
      fontWeight: "bold",
      position: "absolute",
      left: "-25px",
    },
  },
  "& li + li": {
    borderTop: "1px solid #f0f0f0",
  },
};

const pricingRecommendedBadgeSx: SxProps<Theme> = {
  position: "absolute",
  top: "-15px",
  left: "50%",
  transform: "translateX(-50%)",
  background: "#28a745",
  color: "white",
  padding: "8px 20px",
  borderRadius: "20px",
  fontSize: "0.9rem",
  fontWeight: 600,
};

const pricingContactSx: SxProps<Theme> = {
  fontWeight: 600,
  // color: "#fff",
  fontSize: "1.1rem",
  marginTop: "20px",
  textAlign: "center",
  padding: "20px 60px",
  // background: "#28a745",
  borderRadius: "99px",
  boxShadow: "0 5px 15px rgba(0,0,0,0.1)",
  display: "inline-block",
};
